import axios, { AxiosInstance } from "axios";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API || "http://localhost:4100",
  timeout: 10000,
  withCredentials: true,
});

const clearBrowserSession = () => {
  localStorage.clear();
  sessionStorage.clear();

  document.cookie.split(";").forEach((c) => {
    const cookieName = c.replace(/^ +/, "").split("=")[0];
    const expires = `expires=${new Date(0).toUTCString()};path=/`;

    document.cookie = `${cookieName}=;${expires}`;
    document.cookie = `${cookieName}=;${expires};domain=localhost`;
  });
};

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      clearBrowserSession();

      const requestUrl = String(error.config?.url || "");
      const isLoginRequest =
        requestUrl.includes("/api/auth/login") ||
        requestUrl.includes("/auth/login");
      const isLogoutRequest =
        requestUrl.includes("/api/auth/logout") ||
        requestUrl.includes("/auth/logout");

      if (!isLoginRequest && !isLogoutRequest && window.location.pathname !== "/login") {
        window.location.href = "/login?logout=true";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
